module.exports = "/_next/static/images/1dc6fe4408c404c3ba8ec4e6603e5bab-card-lg.png.webp";